import {
    VIDFLEET_SD_CARD_STATUS_REQUEST,
    VIDFLEET_SD_CARD_STATUS_RESULT,
} from 'Redux/actionTypes';

export const sdCardStatusRequest = (filters) => ({
    type: VIDFLEET_SD_CARD_STATUS_REQUEST,
    payload: { filters }
});

export const sdCardStatusResult = (data) => ({
    type: VIDFLEET_SD_CARD_STATUS_RESULT,
    payload: data
});